import {
    completeJob,
    createJob,
    deleteJob,
    getJob,
    getJobList,
    getJobListForUser,
    updateJob,
    updateJobStatus,
} from "../../../api/job";
import { useQuery, useMutation } from "./helper";
import { TResponseItemWrapper, TResponseListWrapper } from "../../types/common";
import { TJob, TJobDetails } from "../../types/job";

export const useJobList = (payload, options) => useQuery<TResponseListWrapper<TJob>>({
    queryKey: ['jobs', payload],
    queryFn: () => getJobList(payload),
    ...options
});

export const useJobListForUser = (payload, options) => useQuery<TResponseListWrapper<TJob>>({
    queryKey: ['jobs', payload],
    queryFn: () => getJobListForUser(payload),
    ...options
});

export const useJob = (id: string | undefined, options) => useQuery<TResponseItemWrapper<TJobDetails>>({
    queryKey: ['job', id],
    queryFn: () => getJob(id),
    ...options,
});

export const useJobStatusUpdate = () => useMutation({
    mutationFn: async (payload) => await updateJobStatus(payload),
});

export const useJobUpdate = () => useMutation({
    mutationFn: async (payload) => await updateJob(payload),
});

export const useJobCreate = () => useMutation({
    mutationFn: async (payload) => await createJob(payload),
});

export const useJobComplete = () => useMutation({
    mutationFn: async (jobId: number) => await completeJob(jobId),
});

export const useJobDelete = () => useMutation({
    mutationFn: async (id) => await deleteJob(id),
});
